import React from "react";
import { Link } from "react-router-dom";

const Deposits = ({ onMenuClick, active }) => {
  return (
    <>
      <li className="nav-item">
        <Link
          to
          className={`nav-link with-sub ${
            active === "/accounts" ||
            active === "/chart-of-account" ||
            active === "/budget-plan" ||
            active === "/journal-code" ||
            active === "/sub-category" ||
            active === "/journal-voucher" ||
            active === "/cash-count" ||
            active === "/setup"
              ? "active show-sub"
              : ""
          }`}
        >
          <i className="fa fa-briefcase" aria-hidden="true"></i>
          <span>&nbsp;&nbsp; Deposits</span>
        </Link>
        <ul className="nav-sub">
          {/* Supply Chain Accounts */}
          <li className="nav-item">
            <Link
              to="/deposit-categories"
              className={`nav-link ${
                active === "/deposit-categories" ? "active" : ""
              }`}
              onClick={() => onMenuClick("/deposit-categories")}
            >
              <i className="fa fa-list" aria-hidden="true"></i>
              &nbsp;&nbsp; Deposit Categories
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/deposits"
              className={`nav-link ${active === "/deposits" ? "active" : ""}`}
              onClick={() => onMenuClick("/deposits")}
            >
              <i className="fa fa-money" aria-hidden="true"></i>
              &nbsp;&nbsp; Deposits
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/daily-collection"
              className={`nav-link ${
                active === "/daily-collection" ? "active" : ""
              }`}
              onClick={() => onMenuClick("/daily-collection")}
            >
              <i className="fa fa-money" aria-hidden="true"></i>
              &nbsp;&nbsp; Daily Collections
            </Link>
          </li>
        </ul>
      </li>
    </>
  );
};

export default Deposits;
